module.exports = __webpack_public_path__ + "2db18452889743b6b4916a11b87b77ac.png";